import { businessToday } from "./businessClock";
/** True when a task has no line items (array or map form). */
export const isTaskEmpty = (task: {
	items?: readonly unknown[] | Record<string, unknown> | null;
}): boolean => {
	const items = task.items;
	if (items == null) return true;
	if (Array.isArray(items)) return items.length === 0;
	return Object.keys(items).length === 0;
};


/**
 * If an empty task is active and its date is not today, bump date to today.
 * Used when selecting/restoring tasks so stale empty drafts don't keep an old date.
 */
export const refreshEmptyActiveTaskDate = <T extends {
	active?: boolean;
	items?: readonly unknown[] | Record<string, unknown> | null;
	date?: string;
	updatedAt?: Date;
}>(task: T): T => {
	if (!task.active || !isTaskEmpty(task)) return task;

	const today = businessToday();
	if (task.date === today) return task;

	return {
		...task,
		date: today,
		updatedAt: new Date(),
	};
};

/** Set which tasks are active; empty newly-active tasks get today's date when stale. */
export const mapTasksWithActivation = <T extends {
	active?: boolean;
	items?: readonly unknown[] | Record<string, unknown> | null;
	date?: string;
	updatedAt?: Date;
}>(
	tasks: T[],
	shouldBeActive: (task: T, index: number) => boolean,
): T[] =>
	tasks.map((task, index) =>
		refreshEmptyActiveTaskDate({
			...task,
			active: shouldBeActive(task, index),
		})
	);
